module.exports = __webpack_public_path__ + "img/Qd.fd9cf556.png";